<template>
    <div class="container">
        <div class="navigation-wrapper">
            <div class="row">
                <div class="col-12">
                    <router-link to="/">
                        <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo" />
                    </router-link>
                </div>
            </div>
        </div>
        <div v-if="successMessage !== ''">
            <div class="alert alert-success">
                {{successMessage}}
            </div>
        </div>

        <div v-for="error in errorMessages" v-bind:key="error">
            <div class="alert alert-danger">
                {{error}}
            </div>
        </div>

        <form v-on:submit="onSubmitVerificationCode" v-if="!validCode && !passwordReset">
            <input type="hidden" v-model="userId">
            <div class="row">
                <div class="col-sm-12">
                    <p>If you received a verification code, please enter it below. If you were able to reset your password via the link in the email, you can return to the member log in page.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <input type="text" required name="uniqueCode"  class="form-control" v-model="uniqueCode" placeholder="Verification Code">
                </div>
            </div>

            <br>
            <div class="row">
                <div class="col-sm-12">
                    <button type="submit" class="btn btn-primary btn-bellstores" :disabled="this.uniqueCode === ''">Verify</button>
                </div>
            </div>
        </form>

        <form v-on:submit="onSubmitPassword">
            <div class="action-container" v-if="validCode && !passwordReset">
                <div class="row">
                    <div class="col-sm-12">
                        <input type="password" required name="password"  class="form-control" :class="{ 'is-valid': passwordsMatch, 'is-invalid': passwordsDontMatch }" v-model="password" placeholder="Password">
                    </div>
                </div>

                <br>
                <div class="row">
                    <div class="col-sm-12">
                        <input type="password" required name="password_confirmation"  class="form-control" :class="{ 'is-valid': passwordsMatch, 'is-invalid': passwordsDontMatch }" v-model="password_confirmation" placeholder="Password Confirmation">
                    </div>
                </div>

                <br>
                <div class="row">
                    <div class="col-sm-12">
                        <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">Submit</button>
                    </div>
                </div>
            </div>
        </form>

        <br>
        <a href="#" v-on:click="back" v-if="!validCode && !passwordReset">re-send email</a>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'ResetPassword',
    dependencies: ['apiService', 'storageService'],
    mounted () {
        this.userId = decodeURIComponent(this.$route.params.userId)
        console.log(this.userId)
    },
    data () {
        return {
            validCode: false,
            password: '',
            password_confirmation: '',
            errorMessages: [],
            userId: '',
            uniqueCode: '',
            successMessage: '',
            passwordReset: false
        }
    },
    computed: {
        isValid () {
            return this.password !== '' && this.password_confirmation !== '' && this.password === this.password_confirmation
        },
        passwordsMatch () {
            return this.password !== '' &&
                this.password_confirmation !== '' &&
                (this.password === this.password_confirmation)
        },
        passwordsDontMatch () {
            return this.password !== '' &&
                this.password_confirmation !== '' &&
                (this.password !== this.password_confirmation)
        }
    },
    methods: {
        async onSubmitPassword (e) {
            e.preventDefault()
            this.errorMessages = []
            const response = await this.apiService.changePassword(this.userId, this.uniqueCode, this.password)

            if (response instanceof APIResponseError || response instanceof APIRequestError) {
                this.errorMessages.push(response.message())
                return
            }

            console.log(response)
            if (response.success()) {
                this.$router.replace('/login')
            }
        },
        async onSubmitVerificationCode (e) {
            e.preventDefault()
            this.errorMessages = []
            const response = await this.apiService.validateCode(this.userId, this.uniqueCode)

            if (response instanceof APIResponseError || response instanceof APIRequestError) {
                this.errorMessages.push(response.message())
                this.validCode = true
                return
            }

            console.log(response)
            if (response.success()) {
                this.validCode = true
            }
        },
        back (e) {
            e.preventDefault()
            this.$router.replace('/forgot_password')
        },
        login (e) {
            e.preventDefault()
            // TODO: would be nice to clear the history here
            this.$router.replace('/login')
        }
    }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue